<div class="layout-column full-height">
  @for (item of items(); track item) {
    <div class="layout-row layout-align-start-center margin-bottom-5">
      <span class="flex br-body-2">{{ item | translate }}</span>
      <bz-button variant="tertiary" size="fit" class="provider-type-remove"
                 appBringozIdGenerator="provider-types-display-list-remove-button"
                 [ariaLabel]="'Remove' | translate"
                 (clicked)="onRemove($event, item)">
        <bz-icon size="sm" [icon]="removeIcon"></bz-icon>
      </bz-button>
    </div>
  }
</div>
